import { Box, Heading, Text } from "@chakra-ui/react";
import StepShell from "../components/StepShell";
import PayPalSelector from "views/customer/order_old/components/payment/PayPalSelector";
import { useStep4Payment } from "../hooks/useStep4Payment";
import PaymentAlerts from "../components/PaymentAlerts";
import CardPaymentSection from "../components/CardPaymentSection";
import AlternativePaymentDivider from "../components/AlternativePaymentDivider";

export default function Step4Payment(props: { onBack: () => void }) {
  const { onBack } = props;

  const {
    cards,
    isGettingCards,
    total,
    canSubmit,
    isPrimaryDisabled,
    error,
    success,
    isSubmitting,
    payment,
    openCardInputForm,
    selectedCard,
    cardHolderName,
    cardBrand,
    paypalRef,
    setCardHolderName,
    selectStripe,
    selectPaypal,
    onSelectCard,
    onToggleAddNewCard,
    onRemoveCard,
    onPayNow,
    onPaypalCompleted,
  } = useStep4Payment();

  return (
    <StepShell
      step={4}
      title="Secure checkout"
      description="Review everything and pay with confidence."
      primaryLabel="Complete order"
      onPrimary={async () => {
        if (!canSubmit) return;
        await onPayNow();
      }}
      secondaryLabel="Back"
      onSecondary={onBack}
      isPrimaryDisabled={isPrimaryDisabled}
      isPrimaryLoading={isSubmitting}
    >
      <Box borderRadius="16px" border="1px solid #E6ECF3" bg="#F5F7FA" p={{ base: "16px", md: "18px" }}>
        <PaymentAlerts error={error} success={success} />

        <Heading fontSize="16px" lineHeight="1.25" fontWeight="600" color="#0B0E10">
          Payment
        </Heading>
        <Text mt="4px" fontSize="14px" fontWeight="400" color="#667085">
          Complete your order with safe, encrypted payment.
        </Text>

        <Box mt="16px">
          <CardPaymentSection
            payment={payment}
            isGettingCards={isGettingCards}
            cards={cards}
            selectedCard={selectedCard}
            openCardInputForm={openCardInputForm}
            cardHolderName={cardHolderName}
            setCardHolderName={setCardHolderName}
            cardBrand={cardBrand}
            selectStripe={selectStripe}
            onSelectCard={onSelectCard}
            onToggleAddNewCard={onToggleAddNewCard}
            onRemoveCard={onRemoveCard}
          />

          <AlternativePaymentDivider />

          <PayPalSelector
            onSelectPayment={(method: string) => {
              if (method === "paypal") {
                selectPaypal();
              }
            }}
            payment={payment || ""}
            ref={paypalRef as any}
            totalPriceOverride={total}
            onCompleted={(orderStatus: number) => {
              onPaypalCompleted(orderStatus);
            }}
          />
        </Box>
      </Box>
    </StepShell>
  );
}
